class FeaturedRecipe extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  async initSwiper() {
    new Swiper(this.querySelector('.featured-recipe__swiper'), {
      slidesPerView: 1.1,
      spaceBetween: 12,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 0,
          navigation: {
            nextEl: '.featured-recipe__swiper-next',
            prevEl: '.featured-recipe__swiper-prev',
          },
          pagination: false,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 0,
          navigation: {
            nextEl: '.featured-recipe__swiper-next',
            prevEl: '.featured-recipe__swiper-prev',
          },
        },
      },
    });
  }
}

customElements.define('featured-recipe', FeaturedRecipe);
